import styled from 'styled-components';
import { spacer8 } from '@spotify-internal/encore-web';
import { SearchModule as EncoreSearchModule } from '@spotify-internal/encore-web/content-platform/components/SearchModule';
import { useT } from '@spotify-internal/i18n-core';

// Overrides Encore's padding and responsive design
const StyledSearchModule = styled(EncoreSearchModule)`
  padding: ${spacer8} 0 36px 0;
`;

interface SearchModuleProps {
  handleSearchChange: (value: string) => void;
  handleSubmit: () => void;
  inputValue: string;
  totalResults: number;
  popOver?: React.ReactNode;
  handleFormInputFocus?: () => void;
  autoComplete?: string;
  lastSearchedTerm: string;
}

export const SearchModule = ({
  handleSearchChange,
  handleSubmit,
  totalResults,
  inputValue,
  popOver,
  handleFormInputFocus,
  autoComplete,
  lastSearchedTerm,
}: SearchModuleProps) => {
  const t = useT();

  return (
    <StyledSearchModule
      title={t('atlas.catalog', 'Catalog', 'Title for the search module')}
      titleAs="h1"
      titleVariant="alto"
      resultCount={totalResults}
      selectedValue={lastSearchedTerm}
      inputValue={inputValue}
      showResultsLabel={
        !!lastSearchedTerm
          ? t(
              'atlas.search.search_module.show_results_for_term',
              `Showing {totalResults, plural,
            one {1 result}
            other {{totalResults} results}} for {searchedTerm}`,
              'Shows how many results are returned for the selected value',
              { totalResults, searchedTerm: lastSearchedTerm },
            )
          : t(
              'atlas.search.search_module.show_results',
              `Showing {totalResults, plural,
            one {1 result}
            other {{totalResults} results}}`,
              'Shows how many results are returned',
              { totalResults },
            )
      }
      inputPlaceholder={t(
        'atlas.search.search_module.input_placeholder',
        'Try a Release ID, URI, name or title',
        'Placeholder text for search module',
      )}
      onSearchChange={handleSearchChange}
      onSubmit={handleSubmit}
      popOver={popOver}
      formInputOnFocus={handleFormInputFocus}
      autoComplete={autoComplete}
    />
  );
};
